<div [innerHtml]="textHTML" class="content" [ngClass]="{ 'slim': slim }"></div>